import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

const BASE_URL = process.env.REACT_APP_API_BASE_URL;
const ServiceCard = ({ service, featured = false, linkState }) => {
    const {
        title,
        image,
        _id,
        metadata,
    } = service;
    const linkProps = linkState ? { state: linkState } : {};
    if (featured) {
        return (
            <div className="swiper-slide text-center">
                <Link to={`/welfare/service/${_id}`} className="card text-center bg-theme text-white" {...linkProps}>
                    <div className="card-body p-1">

                        <figure className="avatar avatar-90 rounded-15 mb-1">
                            <img
                                src={image ? `${BASE_URL}/uploads/documents/${image}` : '/assets/img/default-service.png'}
                                alt={title}
                                style={{ height: '90px', width: '100%', objectFit: 'cover', borderRadius: '12px' }}
                            />
                        </figure>
                        <p className="text-center size-12">
                            {metadata?.provider && <small className="text-muted">{metadata.provider}</small>}
                            {metadata?.provider && <br />}
                            {title}
                        </p>
                    </div>
                </Link>
            </div>
        );
    }

    return (
        <div className="col-6 col-md-4 col-lg-3">
            <div className="card mb-3">
                    <div className="card-body p-1 position-relative">
                        {/* pricing removed from service model */}
                        <Link to={`/welfare/service/${_id}`} {...linkProps}>
                        <figure className="avatar w-100 rounded-15 border">
                            <img
                                src={image ? `${BASE_URL}/uploads/documents/${image}` : '/assets/img/default-service.png'}
                                alt={title}
                                style={{ height: '140px', width: '100%', objectFit: 'scale-down', borderRadius: '12px' }}
                            />
                        </figure>
                    </Link>
                </div>
                    <div className="card-body pt-2">
                        <Link to={`/welfare/service/${_id}`} className="text-decoration-none text-dark" {...linkProps}>
                        <p className="small mb-2">{title}</p>
                        {/* shortDescription and pricing removed from model */}
                    </Link>
                </div>
            </div>
        </div>
    );
};

ServiceCard.propTypes = {
    service: PropTypes.shape({
        title: PropTypes.string.isRequired,
        _id: PropTypes.string.isRequired,
        image: PropTypes.string,
        metadata: PropTypes.object,
    }).isRequired,
    featured: PropTypes.bool,
    linkState: PropTypes.shape({
        fromServicesList: PropTypes.bool,
        listPath: PropTypes.string,
        searchQuery: PropTypes.string,
    }),
};

export default ServiceCard;
